import { describeDate } from "../../../../utils/date";

export const getDialsListForUI = (dailyDials, dialToSync, currentTime) => {
  if (dailyDials) {
    return dailyDials
      .map((dial) => {
        const isCompleted = dial.completed || dialToSync.includes(dial._id);
        const remainingTime = new Date(dial.nextRunOn).getTime() - currentTime;
        const countdown = describeDate(remainingTime / 1000, 30, true);
        return {
          key: dial._id + isCompleted,
          id: dial._id,
          name: dial.name,
          completed: isCompleted,
          data: { ...dial, remainingTime, countdown },
        };
      })
      .sort((a, b) => a.data.remainingTime - b.data.remainingTime);
  }
  return [];
};
